




import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF } from '@/interfaces';

@Component
export default class DeviceCertificateLayoutsOverview extends Mixins(
  OverviewMixin
) {
  public tableCfg = FieldDefs;
}
